import Vue from 'vue'
import App from './App.vue'
import router from './router/index'

// SCSS
import '@/assets/scss/app.scss';

// Bootstrap
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Bootstrap Plugins
import {
  IconsPlugin,
  NavPlugin,
  ListGroupPlugin,
  SidebarPlugin,
  ButtonPlugin,
  LayoutPlugin,
  ModalPlugin,
  FormPlugin,
  FormInputPlugin,
  InputGroupPlugin,
  CollapsePlugin,
  TablePlugin,
  SpinnerPlugin,
  LinkPlugin,
  BadgePlugin,
  AlertPlugin
} from 'bootstrap-vue';

Vue.use(IconsPlugin)
Vue.use(NavPlugin)
Vue.use(ListGroupPlugin)
Vue.use(SidebarPlugin)
Vue.use(ButtonPlugin)
Vue.use(LayoutPlugin)
Vue.use(ModalPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(InputGroupPlugin)
Vue.use(CollapsePlugin)
Vue.use(TablePlugin)
Vue.use(SpinnerPlugin)
Vue.use(LinkPlugin)
Vue.use(BadgePlugin)
Vue.use(AlertPlugin)

// VueCookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies);

// Global filters
Vue.filter('uppercase', function (value) {
  if (!value) return "";
  value = value.toString();
  return value.toUpperCase();
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app');
